import React from "react";
import AuthFormCard from "components/auth-form-card/AuthFormCard";
import AuthForm from "components/auth-form/AuthForm";
import ErrorModal from "modals/error-modal/ErrorModal";
import { useChangePasswordForm } from "./useChangePasswordForm";
import LoadingModal from "modals/loading/LoadingModal";

/**
 * Change-password form — reuses the same AuthFormCard + AuthForm shell as
 * LoginForm so both pages look identical. All state lives in useChangePasswordForm.
 */
function ChangePasswordForm() {
  const {
    fields,
    submitRef,
    isSubmitDisabled,
    showLoading,
    loadingMsg,
    showError,
    errorMsg,
    handleSubmit,
    handleCloseError,
  } = useChangePasswordForm();

  return (
    <>
      <AuthFormCard
        title="Set a new password"
        subtitle="Your account requires a password change before you can continue."
      >
        <AuthForm
          fields={fields}
          submitLabel="Change Password"
          onSubmit={handleSubmit}
          disabled={isSubmitDisabled}
          isLoading={showLoading}
          submitRef={submitRef}
        />
      </AuthFormCard>

      <LoadingModal isOpen={showLoading} loadingMsg={loadingMsg} />

      <ErrorModal
        isOpen={showError}
        errorMsg={errorMsg}
        handleClose={handleCloseError}
      />
    </>
  );
}

export default ChangePasswordForm;
